/**
 * Vocabulaire canonique Produit — partagé client + server.
 *
 * Ce module NE déclare PAS `import 'server-only'` parce qu'il porte des
 * runtime constants (slugs + ordre canonique) légitimement consommées par
 * des Client Components (catégorie cards, switcher, type-switcher fiche).
 * Toute la machinerie serveur (DTOs, services, schemas) vit dans
 * `product.types.ts` qui re-exporte ces valeurs pour les consommateurs
 * backend.
 *
 * Source de vérité unique : la liste, l'ordre, et le sous-ensemble fiche-
 * supporté sont définis ici une seule fois. Toutes les catégories disposent
 * désormais d'une fiche détail backend ; DetailSupportedCategory = ProductCategory.
 */

export type ProductCategory =
    | 'hotels'
    | 'activities'
    | 'cruises'
    | 'transports'
    | 'internationalFlight'
    | 'rentalCars'
    | 'restaurants'
    | 'general';

export const PRODUCT_CATEGORIES: readonly ProductCategory[] = [
    'hotels',
    'activities',
    'cruises',
    'transports',
    'internationalFlight',
    'rentalCars',
    'restaurants',
    'general',
] as const;

export type DetailSupportedCategory = ProductCategory;

const DETAIL_SUPPORTED_CATEGORIES: readonly DetailSupportedCategory[] = [
    'hotels',
    'activities',
    'cruises',
    'transports',
    'internationalFlight',
    'rentalCars',
    'restaurants',
    'general',
] as const;

export function isDetailSupportedCategory(c: ProductCategory): c is DetailSupportedCategory {
    return (DETAIL_SUPPORTED_CATEGORIES as readonly string[]).includes(c);
}
